export const MuiDrawer = {
  styleOverrides: {
    root: {
      '.MuiDrawer-paper': {
        overflowY: 'visible',
        background: 'var(--primary-contrast)',
      },
    },
  },
}
